export default {
  privacyNoticeAlertExpiry: '2023-10-10',
  // clusterDescription is now handled via translations in components
}
